import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError as observableThrowError } from 'rxjs';
import { Configuration } from 'src/app/shared/configuration';
//import { cdpLiteModelService } from '../../../fnol-sg/fnol-sg-model.service';
import { FnolService } from '../../../services/fnol.service';
import { catchError, map } from 'rxjs/operators';
import moment from 'moment';
import { CdpLiteModelService } from './cdp-lite-model.service';

@Injectable({
  providedIn: 'root'
})
export class CommonCdpLiteApiService {

  headerTransactionId: string = '';
  public claimTypeAsUpdated = new BehaviorSubject<object>({});
  public policyHolderDetails = new BehaviorSubject<any>({ policyNo: "", firstName: "", lastName: "", dateOfBirth: "", nric: "" });
  public policyToggle = new BehaviorSubject<object>({ policyToggle: '' });
  public transactionID = new BehaviorSubject<string>('');
  public policyDetails = new BehaviorSubject<object>({});
  public telephoneCodeList = new BehaviorSubject(null);
  public paymentTypeUpdated = new BehaviorSubject<object>({});
  public accountNumberUpdated = new BehaviorSubject<object>({});
  policyDetailData;
  phoneCodeList;

  constructor(
    private http: HttpClient,
    private config: Configuration,
    private cdpLiteModelService: CdpLiteModelService,
    private fnolService: FnolService
  ) {
    this.transactionID.subscribe(res => {
      this.headerTransactionId = res;
    });
    this.policyDetails.subscribe(res => {
      this.policyDetailData = res;
    });
  }

  generateClaimNumberHeaders(): any {
    return {
      headers: new HttpHeaders({
        'email-id': this.config.userEmailID,
        'transactionID': this.headerTransactionId,
        
      })
    };
  }
  generateClaimNumber_cdp_lite(country: string): Observable<object> {
    const unrGenerateClaimNumberURL = this.config.apiEndPoints_cdp_lite?.unrGenerateClaimNumberCommon + country;
    const options = this.generateClaimNumberHeaders();
    return this.http.get(unrGenerateClaimNumberURL, options).pipe(map((res: any) => {
      if (res?.transactionId) {
        if (!this.headerTransactionId) {
          const transacID = res?.transactionId;
          this.transactionID.next(transacID);
          this.fnolService.setTransactionId(transacID);
        }
      }
      return res;
    }), catchError((error: any) => {
      return observableThrowError(error || 'Server error');
    }));
  }
  setFnol_cdp_lite(): Observable<object> {
    const setFnolURL = this.config.apiEndPoints_cdp_lite?.setFnolURL;
    const options = this.generateSetFnolHeader();
    const requestObj = this.cdpLiteModelService.getFnolRequestBody('setFnol', this.policyDetailData, this.phoneCodeList);
    return this.makeHttpPostCall(setFnolURL, requestObj, options);
  }
  finalClaimSubmit_cdp_lite(): Observable<object> {
    const finalSubmitURL = this.config.apiEndPoints_cdp_lite?.setFnolURL;
    const options = this.generateSetFnolHeader();
    const requestObj = this.cdpLiteModelService.getFnolRequestBody('finalSubmit', this.policyDetailData, this.phoneCodeList);
    return this.makeHttpPutCall(finalSubmitURL, requestObj, options);
  }
  getCountryList(): any {
    const list = 'assets/data/locale/en-lite/common/country-list.json';
    return this.http.get(list)
  }
  getCountryListLite(): any {
    const list = 'assets/data/locale/en-lite/common/country-list-lite.json';
    return this.http.get(list)
  }

  getTelephoneCodeList(): any {
    this.http.get('assets/data/locale/en-lite/common/country-telephone-code.json')
      .subscribe(res => {
        this.phoneCodeList = res;
        this.telephoneCodeList.next(res);
      });
  }

  getPolicyDetailsHeaders(): any {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'email-id': this.config.userEmailID,
        
        ...(this.headerTransactionId ? { 'transactionID': this.headerTransactionId } : {})
      }),
    };
  }

  getPolicyDetails(policyNumber = '', nric: string, fname: string, lname: string, dol: Date = null): Observable<object> {
    const params = new HttpParams()
      .set('policyNo', policyNumber)
      .set('dol', dol ? moment(dol).format('YYYY-MM-DD') : '')
      .set('countryCd', 'SG')
      .set('nricNo', nric)
      .set('fname', fname)
      .set('lname', lname);

    const searchPolicyURL = `${this.config.apiEndPoints.searchPolicyURL}?${params.toString()}`;


    return this.http.get(searchPolicyURL, this.getPolicyDetailsHeaders()).pipe(map((res: any) => {

      if (res?.transactionId) {
        if (!this.headerTransactionId) {
          const transacID = res?.transactionId;
          this.transactionID.next(transacID);
          this.fnolService.setTransactionId(transacID);
        }
      }
      if (res.response.policyDetails) {
        this.policyDetailData = res;
        this.policyDetails.next(res);
      }
      return res;
    }), catchError((error: any) => {
      return observableThrowError(error || 'Server error');
    }));
  }

  generateClaimNumber(): Observable<object> {
    const unrGenerateClaimNumberURL = this.config.apiEndPoints.unrGenerateClaimNumberCommon + 'SG';
    const options = this.generateClaimNumberHeaders();
    return this.http.get(unrGenerateClaimNumberURL, options).pipe(map((res: any) => {
      if (res?.transactionId) {
        if (!this.headerTransactionId) {
          const transacID = res?.transactionId;
          this.transactionID.next(transacID);
          this.fnolService.setTransactionId(transacID);
        }
      }
      return res;
    }), catchError((error: any) => {
      return observableThrowError(error || 'Server error');
    }));
  }

  setPolicyHolderDetails(details: any) {
    const holderDetails = {
      policyNo: details['policyNumber'],
      firstName: details['firstName'] || details['policyFirstName'],
      lastName: details['lastName'] || details['policyLastName'],
      dateOfBirth: details['dateOfBirth'] || details['policyDateOfBirth'],
      nric: details['nricFin'] || details['policyNricFin']
    }
    this.policyHolderDetails.next(holderDetails);
    this.cdpLiteModelService.setPolicyHolderDetails(details);
  }

  generateSetFnolHeader(): any {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'email-id': this.config.userEmailID,
        'transactionID': this.headerTransactionId || '',
        
      }),
    };
  }

  makeHttpPostCall(url, data, options): any {
    return this.http.post(url, data, options).pipe(map((res: any) => {
      return res;
    }), catchError((error: any) => {
      return observableThrowError(error || 'Server error');
    }));
  }

  makeHttpPutCall(url, data, options): any {
    return this.http.put(url, data, options).pipe(map((res: any) => {
      return res;
    }), catchError((error: any) => {
      return observableThrowError(error || 'Server error');
    }));
  }

  setFnol(): Observable<object> {
    const setFnolURL = this.config.apiEndPoints.setFnolURL;
    const options = this.generateSetFnolHeader();
    const requestObj = this.cdpLiteModelService.getFnolRequestBody('setFnol', this.policyDetailData, this.phoneCodeList);
    return this.makeHttpPostCall(setFnolURL, requestObj, options);
  }

  finalClaimSubmit(): Observable<object> {
    const finalSubmitURL = this.config.apiEndPoints.setFnolURL + "abc";
    const options = this.generateSetFnolHeader();
    const requestObj = this.cdpLiteModelService.getFnolRequestBody('finalSubmit', this.policyDetailData, this.phoneCodeList);
    return this.makeHttpPutCall(finalSubmitURL, requestObj, options);
  }
}
